import { useRoute } from 'vue-router'

/**
 * Composable for lab-scoped navigation under /maptac/:labId/...
 * Returns a function that prefixes a path with /maptac/:labId.
 * Use only inside routes that have :labId (under /maptac/:labId/...).
 * @returns {(path: string) => string}
 */
export function useLabPath() {
  const route = useRoute()
  return (path) => {
    const labId = route.params.labId
    if (!labId) return path || '/'
    const p = path && path.startsWith('/') ? path : `/${path || ''}`
    return `/maptac/${labId}${p}`
  }
}
